<template>
  <div class="page">
    <tab-view v-model:activeIndex="activeTabIndex" @tab-change="onTabChange">
      <tab-panel v-for="year in tabs" :key="year" :header="year">

        <accordion :multiple="true" :activeIndex="[0, 1]">

          <accordion-tab>
            <template #header>
              <span>POD</span>&nbsp;<span>({{ data_.ridsPod.length + data_.rcusPod.length + data_.datasPod.length }})</span>
            </template>

            <accordion :multiple="true">

              <accordion-tab>
                <template #header>
                  <span>Problemi sui RID</span>&nbsp;<span>({{ data_.ridsPod.length }})</span>
                </template>

                <data-table 
                  :value="data_.ridsPod" 
                  dataKey="id" 

                  sortMode="multiple"
                  responsiveLayout="scroll" 

                  :paginator="true" 
                  :rows="10"
                  :rowsPerPageOptions="[10,25,50]"
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
                  currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"  
                >
                  <template #empty>
                    <div class="box-center">Non sono stati trovati contratti con problemi sui RID.</div>
                  </template>

                  <column field="code" header="Contratto" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/contratti/vendita/${data.id}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.code}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="ragsoc" header="Cliente" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/clienti/${data.cod_cliente}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.ragsoc}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="data_inizio" header="Data Inizio" :sortable="true">
                    <template #body="{data}">
                      {{ (data.data_inizio !== null)? moment(data.data_inizio).format('DD/MM/YYYY'): '' }}
                    </template>
                  </column>
                  <column field="data_fine" header="Data Fine" :sortable="true">
                    <template #body="{data}">
                      {{ (data.data_fine !== null)? moment(data.data_fine).format('DD/MM/YYYY'): '' }}
                    </template>
                  </column>
                  <column field="numero_pod" header="Numero POD" :sortable="true"></column>
                </data-table>

              </accordion-tab>

              <accordion-tab>
                <template #header>
                  <span>Problemi sulle date delle RCU</span>&nbsp;<span>({{ data_.rcusPod.length }})</span>
                </template>

                <data-table 
                  :value="data_.rcusPod" 
                  dataKey="id" 

                  sortMode="multiple"
                  responsiveLayout="scroll" 

                  :paginator="true" 
                  :rows="10"
                  :rowsPerPageOptions="[10,25,50]"
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
                  currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"  
                >
                  <template #empty>
                    <div class="box-center">Non sono stati trovati contratti con problemi sulle date delle RCU.</div>
                  </template>

                  <column field="code" header="Contratto" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/contratti/vendita/${data.id}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.code}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="ragsoc" header="Cliente" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/clienti/${data.cod_cliente}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.ragsoc}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="pod" header="POD" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/pods/${data.cod_pod}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.pod}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="data_inizio" header="Data Inizio" :sortable="true">
                    <template #body="{data}">
                      {{ (data.data_inizio !== null)? moment(data.data_inizio).format('DD/MM/YYYY'): '' }}
                    </template>
                  </column>
                  <column field="data_fine" header="Data Fine" :sortable="true">
                    <template #body="{data}">
                      {{ (data.data_fine !== null)? moment(data.data_fine).format('DD/MM/YYYY'): '' }}
                    </template>
                  </column>
                </data-table>

              </accordion-tab>

              <accordion-tab>
                <template #header>
                  <span>Problemi sui dati presenti nel contratto</span>&nbsp;<span>({{ data_.datasPod.length }})</span>
                </template>

                <data-table 
                  :value="data_.datasPod" 
                  dataKey="id" 

                  sortMode="multiple"
                  responsiveLayout="scroll" 

                  :paginator="true" 
                  :rows="10"
                  :rowsPerPageOptions="[10,25,50]"
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
                  currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"  
                >
                  <template #empty>
                    <div class="box-center">Non sono stati trovati contratti con problemi.</div>
                  </template>

                  <column field="code" header="Contratto" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/contratti/vendita/${data.id}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.code}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="ragsoc" header="Cliente" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/clienti/${data.cod_cliente}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.ragsoc}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="data_inizio" header="Data Inizio" :sortable="true">
                    <template #body="{data}">
                      {{ (data.data_inizio !== null)? moment(data.data_inizio).format('DD/MM/YYYY'): '' }}
                    </template>
                  </column>
                  <column field="data_fine" header="Data Fine" :sortable="true">
                    <template #body="{data}">
                      {{ (data.data_fine !== null)? moment(data.data_fine).format('DD/MM/YYYY'): '' }}
                    </template>
                  </column>
                  <column field="numero_pod" header="Numero POD" :sortable="true"></column>
                </data-table>

              </accordion-tab>

            </accordion>

          </accordion-tab>

          <!-- -->

          <accordion-tab>
            <template #header>
              <span>PDR</span>&nbsp;<span>({{ data_.ridsPdr.length + data_.rcusPdr.length + data_.datasPdr.length }})</span>
            </template>

            <accordion :multiple="true">

              <accordion-tab>
                <template #header>
                  <span>Problemi sui RID</span>&nbsp;<span>({{ data_.ridsPdr.length }})</span>
                </template>

                <data-table 
                  :value="data_.ridsPdr" 
                  dataKey="id" 

                  sortMode="multiple"
                  responsiveLayout="scroll" 

                  :paginator="true" 
                  :rows="10"
                  :rowsPerPageOptions="[10,25,50]"
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
                  currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"  
                >
                  <template #empty>
                    <div class="box-center">Non sono stati trovati contratti con problemi sui RID.</div>
                  </template>

                  <column field="code" header="Contratto" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/contratti/vendita/${data.id}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.code}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="ragsoc" header="Cliente" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/clienti/${data.cod_cliente}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.ragsoc}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="data_inizio" header="Data Inizio" :sortable="true">
                    <template #body="{data}">
                      {{ (data.data_inizio !== null)? moment(data.data_inizio).format('DD/MM/YYYY'): '' }}
                    </template>
                  </column>
                  <column field="data_fine" header="Data Fine" :sortable="true">
                    <template #body="{data}">
                      {{ (data.data_fine !== null)? moment(data.data_fine).format('DD/MM/YYYY'): '' }}
                    </template>
                  </column>
                  <column field="numero_pdr" header="Numero PDR" :sortable="true"></column>
                </data-table>

              </accordion-tab>

              <accordion-tab>
                <template #header>
                  <span>Problemi sulle date delle RCU</span>&nbsp;<span>({{ data_.rcusPdr.length }})</span>
                </template>

                <data-table 
                  :value="data_.rcusPdr" 
                  dataKey="id" 

                  sortMode="multiple"
                  responsiveLayout="scroll" 

                  :paginator="true" 
                  :rows="10"
                  :rowsPerPageOptions="[10,25,50]"
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
                  currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"  
                >
                  <template #empty>
                    <div class="box-center">Non sono stati trovati contratti con problemi sulle date delle RCU.</div>
                  </template>

                  <column field="code" header="Contratto" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/contratti/vendita/${data.id}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.code}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="ragsoc" header="Cliente" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/clienti/${data.cod_cliente}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.ragsoc}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="pdr" header="PDR" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/pdrs/${data.cod_pdr}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.pdr}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="data_inizio" header="Data Inizio" :sortable="true">
                    <template #body="{data}">
                      {{ (data.data_inizio !== null)? moment(data.data_inizio).format('DD/MM/YYYY'): '' }}
                    </template>
                  </column>
                  <column field="data_fine" header="Data Fine" :sortable="true">
                    <template #body="{data}">
                      {{ (data.data_fine !== null)? moment(data.data_fine).format('DD/MM/YYYY'): '' }}
                    </template>
                  </column>
                </data-table>

              </accordion-tab>

              <accordion-tab>
                <template #header>
                  <span>Problemi sui dati presenti nel contratto</span>&nbsp;<span>({{ data_.datasPdr.length }})</span>
                </template>

                <data-table 
                  :value="data_.datasPdr" 
                  dataKey="id" 

                  sortMode="multiple"
                  responsiveLayout="scroll" 

                  :paginator="true" 
                  :rows="10"
                  :rowsPerPageOptions="[10,25,50]"
                  paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
                  currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"  
                >
                  <template #empty>
                    <div class="box-center">Non sono stati trovati contratti con problemi.</div>
                  </template>

                  <column field="code" header="Contratto" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/contratti/vendita/${data.id}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.code}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="ragsoc" header="Cliente" :sortable="true">
                    <template #body="{ data }">
                      <router-link
                        :to="`/ask/clienti/${data.cod_cliente}/dettagli`"
                        custom
                        v-slot="{ href }"
                      >
                        <prime-button 
                          :label="`${data.ragsoc}`" 
                          class="p-button-info p-button-text"
                          @click="navigateToTab(href)" 
                        />
                      </router-link>
                    </template>
                  </column>
                  <column field="data_inizio" header="Data Inizio" :sortable="true">
                    <template #body="{data}">
                      {{ (data.data_inizio !== null)? moment(data.data_inizio).format('DD/MM/YYYY'): '' }}
                    </template>
                  </column>
                  <column field="data_fine" header="Data Fine" :sortable="true">
                    <template #body="{data}">
                      {{ (data.data_fine !== null)? moment(data.data_fine).format('DD/MM/YYYY'): '' }}
                    </template>
                  </column>
                  <column field="numero_pdr" header="Numero PDR" :sortable="true"></column>
                </data-table>

              </accordion-tab>

            </accordion>

          </accordion-tab>

        </accordion>

      </tab-panel>
    </tab-view>
  </div>
</template>

<script>
import moment from 'moment'

import Service from '@/services/ask-management/verifica-contratti-vendita-service.js'

import PrimeButton from 'primevue/button'

export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  
  components: {
    PrimeButton,
  },

  data() {
    return {
      moment,

      page:{
        name: 'contratti-vendita-anomalie',
      },

      tabs: [],
      activeTabIndex: 0,

      data_: {
        contrattiIds: this.data,

        ridsPod: [],
        rcusPod: [],
        datasPod: [],

        ridsPdr: [],
        rcusPdr: [],
        datasPdr: [],
      },
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)
    
    this.tabs = [...Array(2).keys()].map(i => new Date().getFullYear() - i)

    this.getAllErroriPodRid()
    this.getAllErroriPodRcu()
    this.getAllErroriPodData()

    this.getAllErroriPdrRid()
    this.getAllErroriPdrRcu()
    this.getAllErroriPdrData()
  },

  methods:{
  
    onCancelButton(){
      this._reset()

      this.$eventBus.emit('dialog-return-cancel-button', {})
    },

    ////

    onTabChange(/** evt **/){
      this.data_.ridsPod = []
      this.data_.rcusPod = []
      this.data_.datasPod = []

      this.getAllErroriPodRid()
      this.getAllErroriPodRcu()
      this.getAllErroriPodData()

      this.getAllErroriPdrRid()
      this.getAllErroriPdrRcu()
      this.getAllErroriPdrData()
    },

    ////

    _reset(){
      this.tabs = []
      this.activeTabIndex = 0

      this.data_.contrattiIds = []

      this.data_.ridsPod = []
      this.data_.rcusPod = []
      this.data_.datasPod = []

      this.data_.ridsPdr = []
      this.data_.rcusPdr = []
      this.data_.datasPdr = []
    },

    navigateToTab(href){
      window.open(href, '_blank')
    },

    getAllErroriPodRid(){
      const opts = (this.data_.contrattiIds.length > 0) ? 
      {
        'contratto_vendita.ids': this.data_.contrattiIds
      }: 
      {}
      
      this.service.getAllErroriPodRidByYear(this.currentYear, opts)
      .then((res) => {
        this.data_.ridsPod = res.items.map((el) =>{
          if(el.ragsoc == null){
            el.ragsoc = ''
          }

          if(el.data_fine == '2099-12-31'){
            el.data_fine = null
          }

          el.numero_pod = el.pod + el.pod_volturati

          return el
        })
      })
    },

    getAllErroriPodRcu(){
      const opts = (this.data_.contrattiIds.length > 0) ? 
      {
        'contratto_vendita.ids': this.data_.contrattiIds
      }: 
      {}
      
      this.service.getAllErroriPodRcuByYear(this.currentYear, opts)
      .then((res) => {
        this.data_.rcusPod = res.items.map((el) =>{
          if(el.ragsoc == null){
            el.ragsoc = ''
          }

          if(el.data_fine == '2099-12-31'){
            el.data_fine = null
          }

          return el
        })
      })
    },

    getAllErroriPodData(){
      const opts = (this.data_.contrattiIds.length > 0) ? 
      {
        'contratto_vendita.ids': this.data_.contrattiIds
      }: 
      {}
      
      this.service.getAllErroriPodDataByYear(this.currentYear, opts)
      .then((res) => {
        this.data_.datasPod = res.items.map((el) =>{
          if(el.ragsoc == null){
            el.ragsoc = ''
          }

          if(el.data_fine == '2099-12-31'){
            el.data_fine = null
          }

          el.numero_pod = el.pod + el.pod_volturati

          return el
        })
      })
    },

    getAllErroriPdrRid(){
      const opts = (this.data_.contrattiIds.length > 0) ? 
      {
        'contratto_vendita.ids': this.data_.contrattiIds
      }: 
      {}
      
      this.service.getAllErroriPdrRidByYear(this.currentYear, opts)
      .then((res) => {
        this.data_.ridsPdr = res.items.map((el) =>{
          if(el.ragsoc == null){
            el.ragsoc = ''
          }

          if(el.data_fine == '2099-12-31'){
            el.data_fine = null
          }

          el.numero_pdr = el.pdr + el.pdr_volturati

          return el
        })
      })
    },

    getAllErroriPdrRcu(){
      const opts = (this.data_.contrattiIds.length > 0) ? 
      {
        'contratto_vendita.ids': this.data_.contrattiIds
      }: 
      {}
      
      this.service.getAllErroriPdrRcuByYear(this.currentYear, opts)
      .then((res) => {
        this.data_.rcusPdr = res.items.map((el) =>{
          if(el.ragsoc == null){
            el.ragsoc = ''
          }

          if(el.data_fine == '2099-12-31'){
            el.data_fine = null
          }

          return el
        })
      })
    },

    getAllErroriPdrData(){
      const opts = (this.data_.contrattiIds.length > 0) ? 
      {
        'contratto_vendita.ids': this.data_.contrattiIds
      }: 
      {}
      
      this.service.getAllErroriPdrDataByYear(this.currentYear, opts)
      .then((res) => {
        this.data_.datasPdr = res.items.map((el) =>{
          if(el.ragsoc == null){
            el.ragsoc = ''
          }

          if(el.data_fine == '2099-12-31'){
            el.data_fine = null
          }

          el.numero_pdr = el.pdr + el.pdr_volturati

          return el
        })
      })
    },

  },

  computed:{
    currentYear: function(){
      return this.tabs[this.activeTabIndex]
    },
  },
}
</script>

<style scoped>
  .box-center{
    text-align: center;
  }
</style>
